/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Material_Tracking_Mode_Quantity_DescInputs */

const vi_packaging_material_tracking_mode_quantity_desc = /** @type {(inputs: Packaging_Material_Tracking_Mode_Quantity_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Theo số lượng (không lô)`)
};

/**

* @param {Packaging_Material_Tracking_Mode_Quantity_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_material_tracking_mode_quantity_desc = /** @type {((inputs?: Packaging_Material_Tracking_Mode_Quantity_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Material_Tracking_Mode_Quantity_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_material_tracking_mode_quantity_desc(inputs)
});